// Website agent actions
export const ADD_WEBSITE_AGENT = "ADD_WEBSITE_AGENT";
export const ADD_WEBSITE_AGENT_SUCCESS = "ADD_WEBSITE_AGENT_SUCCESS";
export const ADD_WEBSITE_AGENT_FAILED = "ADD_WEBSITE_AGENT_FAILED";

export const FETCH_USER = "FETCH_USER";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILED = "FETCH_USER_FAILED";
export const USER_SIGN_IN = "USER_SIGN_IN";
export const USER_SIGN_IN_FAILED = "SIGN_IN_FAILED";
export const USER_SIGN_OUT = "USER_SIGN_OUT";
export const CLEAR_LOGIN_ERROR = "CLEAR_LOGIN_ERROR";
export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE";
export const USER_NOT_REGISTERED = "USER_NOT_REGISTERED";
export const USER_DELETED = "USER_DELETED";
export const REQUEST_OTP = "REQUEST_OTP";
export const REQUEST_OTP_SUCCESS = "REQUEST_OTP_SUCCESS";
export const REQUEST_OTP_FAILED = "REQUEST_OTP_FAILED";
export const USER_SIGNUP_START = "USER_SIGNUP_START";
export const USER_SIGNUP_FAILED = "USER_SIGNUP_FAILED";
export const USER_SIGNUP_SUCCESS = "USER_SIGNUP_SUCCESS";


export const FETCH_USERS_BRANCHES_START = "FETCH_USERS_BRANCHES_START";
export const FETCH_USERS_BRANCHES_SUCCESS = "FETCH_USERS_BRANCHES_SUCCESS";
export const FETCH_USERS_BRANCHES_FAILED = "FETCH_USERS_BRANCHES_FAILED";

export const SYNC_TO_PROP24 = "SYNC_TO_PROP24";
export const SYNC_TO_PROP24_SUCCESS = "SYNC_TO_PROP24_SUCCESS";
export const SYNC_TO_PROP24_FAILED = "SYNC_TO_PROP24_FAILED";

export const SYNC_TO_PRIVATEPROP = "SYNC_TO_PRIVATEPROP";
export const SYNC_TO_PRIVATEPROP_SUCCESS = "SYNC_TO_PRIVATEPROP_SUCCESS";
export const SYNC_TO_PRIVATEPROP_FAILED = "SYNC_TO_PRIVATEPROP_FAILED";


export const STATUS_UPDATE_P24 = "STATUS_UPDATE_P24";
export const STATUS_UPDATE_P24_SUCCESS = "STATUS_UPDATE_P24_SUCCESS";
export const STATUS_UPDATE_P24_FAILED = "STATUS_UPDATE_P24_FAILED";


export const SYNC_TO_WEBSITE = "SYNC_TO_WEBSITE";
export const SYNC_TO_WEBSITE_SUCCESS = "SYNC_TO_WEBSITE_SUCCESS";
export const SYNC_TO_WEBSITE_FAILED = "SYNC_TO_WEBSITE_FAILED";


export const PP_TOKEN_GENERATE_START = "PP_TOKEN_GENERATE_START";
export const PP_TOKEN_GENERATE_SUCCUSS = "PP_TOKEN_GENERATE_SUCCUSS";
export const PP_TOKEN_GENERATE_FAIL = "PP_TOKEN_GENERATE_FAIL";
export const CLEAR_TOKEN_ERROR = "CLEAR_TOKEN_ERROR";


export const PP_LEADS_FETCH_START = "PP_LEADS_FETCH_START";
export const PP_LEADS_FETCH_SUCCUSS = "PP_LEADS_FETCH_SUCCUSS";
export const PP_LEADS_FETCH_FAIL = "PP_LEADS_FETCH_FAIL";

export const P24_LEADS_FETCH_START = "P24_LEADS_FETCH_START";
export const P24_LEADS_FETCH_SUCCUSS = "P24_LEADS_FETCH_SUCCUSS";
export const P24_LEADS_FETCH_FAIL = "P24_LEADS_FETCH_FAIL";

export const PP_LISTINGS_ACTIVITY_FETCH_START = "PP_LISTINGS_ACTIVITY_FETCH_START";
export const PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS = "PP_LISTINGS_ACTIVITY_FETCH_SUCCUSS";
export const PP_LISTINGS_ACTIVITY_FETCH_FAIL = "PP_LISTINGS_ACTIVITY_FETCH_FAIL";

export const FETCH_PPREF = "FETCH_PPREF";
export const FETCH_PPREF_SUCCESS = "FETCH_PPREF_SUCCESS";
export const FETCH_PPREF_FAIL = "FETCH_PPREF_FAIL";


//*=============================================
//=           AI TYPES                       =
//=============================================*/



/* Create */
export const GENERATE_KEYWORDS_START = "GENERATE_KEYWORDS_START";
export const GENERATE_KEYWORDS_SUCCESS = "GENERATE_KEYWORDS_SUCCESS";
export const GENERATE_KEYWORDS_FAILED = "GENERATE_KEYWORDS_FAILED";

export const GENERATE_HEADINGS_START = "GENERATE_HEADINGS_START";
export const GENERATE_HEADINGS_SUCCESS = "GENERATE_HEADINGS_SUCCESS";
export const GENERATE_HEADINGS_FAILED = "GENERATE_HEADINGS_FAILED";
export const SAVE_SELECTED_HEADING = "SAVE_SELECTED_HEADING";



export const GENERATE_DESCRIPTION_START = "GENERATE_DESCRIPTION_START";
export const GENERATE_DESCRIPTION_SUCCESS = "GENERATE_DESCRIPTION_SUCCESS";
export const GENERATE_DESCRIPTION_FAILED = "GENERATE_DESCRIPTION_FAILED";


export const CLEAR_AI_REDUCER = "CLEAR_AI_REDUCER";


/*=====  End of AI TYPES  ======*/


export const FETCH_BROKER_REGIONS_START = "FETCH_BROKER_REGIONS_START";
export const FETCH_BROKER_REGIONS_SUCCESS = "FETCH_BROKER_REGIONS_SUCCESS";
export const FETCH_BROKER_REGIONS_FAILED = "FETCH_BROKER_REGIONS_FAILED";

export const EDIT_BOOKING_OFFERS = "EDIT_BOOKING_OFFERS";
export const NO_BOOKING_OFFERS = "NO_BOOKING_OFFERS";
export const FETCH_BOOKING_OFFERS = "FETCH_BOOKING_OFFERS";
export const FETCH_BOOKING_OFFERS_SUCCESS = "FETCH_BOOKING_OFFERS_SUCCESS";
export const FETCH_BOOKING_OFFERS_FAILED = "FETCH_BOOKING_OFFERS_FAILED";
export const CANCEL_BOOKING_OFFER = "CANCEL_BOOKING_OFFER";

export const FETCH_REFERRALS_TYPE = "FETCH_REFERRALS_TYPE";
export const FETCH_REFERRALS_TYPES = "FETCH_REFERRALS_TYPES";
export const FETCH_REFERRALS_TYPES_SUCCESS = "FETCH_REFERRALS_TYPES_SUCCESS";
export const FETCH_REFERRALS_TYPES_FAILED = "FETCH_REFERRALS_TYPES_FAILED";
export const EDIT_REFERRALS_TYPE = "EDIT_REFERRALS_TYPE";

export const ADD_CARD = "ADD_CARD";
export const ADD_CARD_SUCCESS = "ADD_CARD_SUCCESS";
export const ADD_CARD_FAILED = "ADD_CARD_FAILED";

export const ADD_MEDICAL_AID = "ADD_MEDICAL_AID";
export const ADD_MEDICAL_AID_SUCCESS = "ADD_MEDICAL_AID_SUCCESS";
export const ADD_MEDICAL_AID_FAILED = "ADD_MEDICAL_AID_FAILED";

export const FETCH_MEDICAL_HISTORY = "FETCH_MEDICAL_HISTORY";
export const FETCH_MEDICAL_HISTORY_SUCCESS = "FETCH_MEDICAL_HISTORY_SUCCESS";
export const FETCH_MEDICAL_HISTORY_FAILURE = "FETCH_MEDICAL_HISTORY_FAILURE";
export const FETCH_MEDICAL_HISTORY_EDIT = "FETCH_MEDICAL_HISTORY_EDIT";
export const NO_MEDICAL_HISTORY = "NO_MEDICAL_HISTORY";

export const FETCH_REFERRAL_TYPES = "FETCH_REFERRAL_TYPES";
export const FETCH_REFERRAL_TYPES_SUCCESS = "FETCH_REFERRAL_TYPES_SUCCESS";
export const FETCH_REFERRAL_TYPES_FAILED = "FETCH_REFERRAL_TYPES_FAILED";
export const EDIT_REFERRAL_TYPE = "EDIT_REFERRAL_TYPE";

export const FETCH_PRACTICE_TYPES = "FETCH_PRACTICE_TYPES";
export const FETCH_PRACTICE_TYPES_SUCCESS = "FETCH_PRACTICE_TYPES_SUCCESS";
export const FETCH_PRACTICE_TYPES_FAILED = "FETCH_PRACTICE_TYPES_FAILED";
export const EDIT_PRACTICE_TYPE = "EDIT_PRACTICE_TYPE";

export const FETCH_REFERRALDR_TYPES = "FETCH_REFERRALDR_TYPES";
export const FETCH_REFERRALDR_TYPES_SUCCESS = "FETCH_REFERRALDR_TYPES_SUCCESS";
export const FETCH_REFERRALDR_TYPES_FAILED = "FETCH_REFERRALDR_TYPES_FAILED";
export const EDIT_REFERRALDR_TYPE = "EDIT_REFERRALDR_TYPE";

export const FETCH_TREATMENT_TYPES = "FETCH_TREATMENT_TYPES";
export const FETCH_TREATMENT_TYPES_SUCCESS = "FETCH_TREATMENT_TYPES_SUCCESS";
export const FETCH_TREATMENT_TYPES_FAILED = "FETCH_TREATMENT_TYPES_FAILED";
export const EDIT_TREATMENT_TYPE = "EDIT_TREATMENT_TYPE";

export const FETCH_BOOKINGS = "FETCH_BOOKINGS";
export const FETCH_BOOKINGS_SUCCESS = "FETCH_BOOKINGS_SUCCESS";
export const FETCH_BOOKINGS_FAILED = "FETCH_BOOKINGS_FAILED";
export const UPDATE_BOOKING = "UPDATE_BOOKING";
export const CANCEL_BOOKING = "CANCEL_BOOKING";
export const FETCH_ALL_BOOKINGS = "FETCH_ALL_BOOKINGS";
export const FETCH_ALL_BOOKINGS_SUCCESS = "FETCH_ALL_BOOKINGS_SUCCESS";
export const FETCH_ALL_BOOKINGS_FAILED = "FETCH_ALL_BOOKINGS_FAILED";
export const UPDATE_ALL_BOOKING = "UPDATE_ALL_BOOKING";
export const CANCEL_ALL_BOOKING = "CANCEL_ALL_BOOKING";

export const FETCH_ESTIMATE = "FETCH_ESTIMATE";
export const FETCH_ESTIMATE_SUCCESS = "FETCH_ESTIMATE_SUCCESS";
export const FETCH_ESTIMATE_FAILED = "FETCH_ESTIMATE_FAILED";
export const CLEAR_ESTIMATE = "CLEAR_ESTIMATE";

// export const CREATE_MEETING= "CREATE_MEETING";
// export const CREATE_MEETING_SUCCESS= "CREATE_MEETING_SUCCESS";
// export const CREATE_MEETING_FAIL= "CREATE_MEETING_FAIL";
// export const DELETE_MEETING= "DELETE_MEETING";
// export const DELETE_MEETING_SUCCESS= "DELETE_MEETING_SUCCESS";
// export const DELETE_MEETING_FAIL= "DELETE_MEETING_FAIL";

export const CONFIRM_BOOKING = "CONFIRM_BOOKING";
export const CONFIRM_BOOKING_SUCCESS = "CONFIRM_BOOKING_SUCCESS";
export const CONFIRM_BOOKING_FAILED = "CONFIRM_BOOKING_FAILED";
export const CLEAR_BOOKING = "CLEAR_BOOKING";
/*==========================================================================*/
//Area Types

// Create
export const CREATE_AREA_START = "CREATE_AREA_START";
export const CREATE_AREA_SUCCESS = "CREATE_AREA_SUCCESS";
export const CREATE_AREA_FAIL = "CREATE_AREA_FAIL";

// Update
export const UPDATE_AREA_START = "UPDATE_AREA_START";
export const UPDATE_AREA_SUCCESS = "UPDATE_AREA_SUCCESS";
export const UPDATE_AREA_FAIL = "UPDATE_AREA_FAIL";

//Remove
export const REMOVE_BROKER_START = "REMOVE_BROKER_START";
export const REMOVE_BROKER_SUCCESS = "REMOVE_BROKER_SUCCESS";
export const REMOVE_BROKER_FAIL = "REMOVE_BROKER_FAIL";

// Update
export const DELETE_AREA_START = "DELETE_AREA_START";
export const DELETE_AREA_SUCCESS = "DELETE_AREA_SUCCESS";
export const DELETE_AREA_FAIL = "DELETE_AREA_FAIL";

// Fetch
export const FETCH_AREAS_START = "FETCH_AREAS_START";
export const FETCH_AREAS_SUCCESS = "FETCH_AREAS_SUCCESS";
export const FETCH_AREAS_FAILED = "FETCH_AREAS_FAILED";
export const FETCH_WEBSITE_AREAS_START = "FETCH_WEBSITE_AREAS_START";
export const FETCH_WEBSITE_AREAS_SUCCESS = "FETCH_WEBSITE_AREAS_SUCCESS";
export const FETCH_WEBSITE_AREAS_FAILED = "FETCH_WEBSITE_AREAS_FAILED";

// Clear error
export const CLEAR_AREA_ERROR = "CLEAR_AREA_ERROR";

//Fetch unAssigned Areas
export const FETCH_UNASSIGNED_AREAS_START = "FETCH_UNASSIGNED_AREAS_START";
export const FETCH_UNASSIGNED_AREAS_SUCCESS = "FETCH_UNASSIGNED_AREAS_SUCCESS";
export const FETCH_UNASSIGNED_AREAS_FAIL = "FETCH_UNASSIGNED_AREAS_FAIL";

//Fetch Assigned Areas
export const FETCH_ASSIGNED_AREAS_START = "FETCH_ASSIGNED_AREAS_START";
export const FETCH_ASSIGNED_AREAS_SUCCESS = "FETCH_ASSIGNED_AREAS_SUCCESS";
export const FETCH_ASSIGNED_AREAS_FAIL = "FETCH_ASSIGNED_AREAS_FAIL";

/*==========================================================================*/

//Region Types
export const CREATE_REGION_START = "CREATE_REGION_START";
export const CREATE_REGION_FAILED = "CREATE_REGION_FAILED";
export const CREATE_REGION_SUCCESS = "CREATE_REGION_SUCCESS";
export const FETCH_REGIONS_START = "FETCH_REGIONS_START";
export const FETCH_REGIONS_SUCCESS = "FETCH_REGIONS_SUCCESS";
export const FETCH_REGIONS_FAILED = "FETCH_REGIONS_FAILED";
export const CLEAR_REGION_ERROR = "CLEAR_REGION_ERROR";
export const UPDATE_REGION_START = "UPDATE_REGION_START";
export const UPDATE_REGION_SUCCESS = "UPDATE_REGION_SUCCESS";
export const UPDATE_REGION_FAIL = "UPDATE_REGION_FAIL";
export const DELETE_REGION_START = "DELETE_REGION_START";
export const DELETE_REGION_SUCCESS = "DELETE_REGION_SUCCESS";
export const DELETE_REGION_FAIL = "DELETE_REGION_FAIL";
export const REMOVE_REGION_START = "REMOVE_REGION_START";
export const REMOVE_REGION_SUCCESS = "REMOVE_REGION_SUCCESS";
export const REMOVE_REGION_FAIL = "REMOVE_REGION_FAIL";
export const REMOVE_AREA_START = "REMOVE_AREA_START";
export const REMOVE_AREA_FAIL = "REMOVE_AREA_FAIL";
export const REMOVE_AREA_SUCCESS = "REMOVE_AREA_SUCCESS";
//Enquiry Types

//Create

export const CREATE_ENQUIRY_START = "CREATE_ENQUIRY_START";
export const CREATE_ENQUIRY_SUCCESS = "CREATE_ENQUIRY_SUCCESS";
export const CREATE_ENQUIRY_FAILED = "CREATE_ENQUIRY_FAILED";

//Delete

export const DELETE_ENQUIRY_START = "DELETE_ENQUIRY_START";
export const DELETE_ENQUIRY_SUCCESS = "DELETE_ENQUIRY_SUCCESS";
export const DELETE_ENQUIRY_FAILED = "DELETE_ENQUIRY_FAILED";

//Mark as unread
export const MARK_ENQUIRY_UNREAD_START = "MARK_ENQUIRY_UNREAD_START";
export const MARK_ENQUIRY_UNREAD_SUCCESS = "MARK_ENQUIRY_UNREAD_SUCCESS";
export const MARK_ENQUIRY_UNREAD_FAILED = "MARK_ENQUIRY_UNREAD_FAILED";

//Update

export const UPDATE_ENQUIRY_START = "UPDATE_ENQUIRY_START";
export const UPDATE_ENQUIRY_SUCCESS = "UPDATE_ENQUIRY_SUCCESS";
export const UPDATE_ENQUIRY_FAILED = "UPDATE_ENQUIRY_FAILED";
export const UPDATE_PULLFORWARD_ENQUIRY_SUCCESS = "UPDATE_PULLFORWARD_ENQUIRY_SUCCESS";
export const CLEAR_PULLFORWARD_ENQUIRY_SUCCESS = "CLEAR_PULLFORWARD_ENQUIRY_SUCCESS";
export const UPDATE_PULLFORWARD_LISTING_SUCCESS = "UPDATE_PULLFORWARD_LISTING_SUCCESS";

//Fetch
export const FETCH_ENQUIRY_START = "FETCH_ENQUIRY_START";
export const FETCH_ENQUIRY_SUCCESS = "FETCH_ENQUIRY_SUCCESS";
export const FETCH_ENQUIRY_FAILED = "FETCH_ENQUIRY_FAILED";

//Fetch
export const FETCH_BRANCH_ENQUIRIES_START = "FETCH_BRANCH_ENQUIRIES_START";
export const FETCH_BRANCH_ENQUIRIES_SUCCESS = "FETCH_BRANCH_ENQUIRIES_SUCCESS";
export const FETCH_BRANCH_ENQUIRIES_FAILED = "FETCH_BRANCH_ENQUIRIES_FAILED";

export const FETCH_ENQUIRIES_FAILED = "FETCH_ENQUIRIES_FAILED";

export const ARCHIVE_ENQUIRY_START = "ARCHIVE_ENQUIRY_START";
export const ARCHIVE_ENQUIRY_SUCCESS = "ARCHIVE_ENQUIRY_SUCCESS";

export const ADD_ENQUIRY_TO_CALLLIST_START = "ADD_ENQUIRY_TO_CALLLIST_START";
export const ADD_ENQUIRY_TO_CALLLIST_SUCCUSS =
  "ADD_ENQUIRY_TO_CALLLIST_SUCCUSS";

export const ADD_ENQUIRY_TO_WHITEBOARD_START =
  "ADD_ENQUIRY_TO_WHITEBOARD_START";
export const ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS =
  " ADD_ENQUIRY_TO_WHITEBOARD_SUCCESS";

export const ADD_ENQUIRY_TO_INVESTOR_START = "ADD_ENQUIRY_TO_INVESTOR_START";
export const ADD_ENQUIRY_TO_INVESTOR_SUCCESS =
  " ADD_ENQUIRY_TO_INVESTOR_SUCCESS";

export const ADD_ENQUIRY_TO_INVESTORS_START = "ADD_ENQUIRY_TO_INVESTORS_START";
export const ADD_ENQUIRY_TO_INVESTORS_SUCCUSS =
  "ADD_ENQUIRY_TO_INVESTORS_SUCCUSSS";

export const REMOVE_ENQUIRY_FROM_CALLLIST_START =
  "REMOVE_ENQUIRY_FROM_CALLLIST_START";
export const REMOVE_ENQUIRY_FROM_CALLLIST_SUCCESS =
  "REMOVE_ENQUIRY_FROM_CALLLIST_SUCCUSS";

export const REMOVE_ENQUIRY_FROM_WHITEBOARD_START =
  "REMOVE_ENQUIRY_FROM_WHITEBOARD_START";
export const REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS =
  "REMOVE_ENQUIRY_FROM_WHITEBOARD_SUCCESS";

export const REMOVE_ENQUIRY_FROM_INVESTOR_START =
  "REMOVE_ENQUIRY_FROM_INVESTOR_START";
export const REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS =
  "REMOVE_ENQUIRY_FROM_INVESTOR_SUCCESS";

export const UNARCHIVE_ENQUIRY_START = "UNARCHIVE_ENQUIRY_START";
export const UNARCHIVE_ENQUIRY_SUCCESS = "UNARCHIVE_ENQUIRY_SUCCESS";

export const VIEW_ENQUIRY_START = "VIEW_ENQUIRY_START";
export const VIEW_ENQUIRY_SUCCESS = "VIEW_ENQUIRY_SUCCESS";

export const FETCH_RECENT_ENQUIRIES_SUCCESS = "FETCH_RECENT_ENQUIRIES_SUCCESS";
//Error
export const ENQUIRY_ERROR = "ENQUIRY_ERROR";
export const CLEAR_ENQUIRY_ERROR = "CLEAR_ENQUIRY_ERROR";

export const FETCH_ENQUIRIES_START = "FETCH_ENQUIRIES_START";
export const FETCH_ENQUIRIES_SUCCESS = "FETCH_ENQUIRIES_SUCCESS";
export const ARCHIVE_ENQUIRY_FAILED = "FETCH_ENQUIRIES_FAILED";
export const VIEW_ENQUIRY_FAILED = "VIEW_ENQUIRY_FAILED";

//TIMELINE

export const FETCH_TIMELINE_START = "FETCH_TIMELINE_START";
export const FETCH_TIMELINE_SUCCUSS = "FETCH_TIMELINE_SUCCUSS";
export const FETCH_TIMELINE_FAILED = "FETCH_TIMELINE_FAILED";

/*==========================================================================*/

// Branch Action Types

// Create
export const CREATE_BRANCH_START = "CREATE_BRANCH_START";
export const CREATE_BRANCH_SUCCESS = "CREATE_BRANCH_SUCCESS";
export const CREATE_BRANCH_FAILED = "CREATE_BRANCH_FAILED";

// Update
export const UPDATE_BRANCH_START = "UPDATE_BRANCH_START";
export const UPDATE_BRANCH_SUCCESS = "UPDATE_BRANCH_SUCCESS";
export const UPDATE_BRANCH_FAILED = "UPDATE_BRANCH_FAILED";

// Delete
export const DELETE_BRANCH_START = "DELETE_BRANCH_START";
export const DELETE_BRANCH_SUCCESS = "DELETE_BRANCH_SUCCESS";
export const DELETE_BRANCH_FAILED = "DELETE_BRANCH_FAILED";

// Fetch
export const FETCH_BRANCHES_START = "FETCH_BRANCHES_START";
export const FETCH_BRANCHES_SUCCESS = "FETCH_BRANCHES_SUCCESS";
export const FETCH_BRANCHES_FAILED = "FETCH_BRANCHES_FAILED";

//Clear error
export const CLEAR_BRANCH_ERROR = "CLEAR_BRANCH_ERROR";

/*==========================================================================*/

//Listing Types

//Create

export const CREATE_LISTING_START = "CREATE_LISTING_START";
export const CREATE_LISTING_SUCCESS = "CREATE_LISTING_SUCCESS";
export const CREATE_LISTING_FAILED = "CREATE_LISTING_FAILED";

//Delete

export const DELETE_LISTING_START = "DELETE_LISTING_START";
export const DELETE_LISTING_SUCCESS = "DELETE_LISTING_SUCCESS";
export const DELETE_LISTING_FAILED = "DELETE_LISTING_FAILED";

//Update

export const UPDATE_LISTING_START = "UPDATE_LISTING_START";
export const UPDATE_LISTING_SUCCESS = "UPDATE_LISTING_SUCCESS";
export const UPDATE_LISTING_FAILED = "UPDATE_LISTING_FAILED";


export const  UPDATE_LISTING_INFO_FAILED = "UPDATE_LISTING_INFO_FAILED";
export const  UPDATE_LISTING_INFO_SUCCESS = "UPDATE_LISTING_INFO_SUCCESS";
export const  UPDATE_LISTING_INFO_START = "UPDATE_LISTING_INFO_START";
export const  CLEAR_LISTING_INFO_ERROR = "CLEAR_LISTING_INFO_ERROR";

//Duplicate
export const DUPLICATE_LISTING_START = "DUPLICATE_LISTING_START";
export const DUPLICATE_LISTING_SUCCESS = "DUPLICATE_LISTING_SUCCESS";
export const DUPLICATE_LISTING_FAILED = "DUPLICATE_LISTING_FAILED";

//Fetch
export const FETCH_LISTING_START = "FETCH_LISTING_START";
export const FETCH_LISTING_SUCCESS = "FETCH_LISTING_SUCCESS";
export const FETCH_LISTING_FAILED = "FETCH_LISTING_FAILED";

export const FETCH_LISTING_BY_BRANCH_START = "FETCH_LISTING_BY_BRANCH_START";
export const FETCH_LISTING_BY_BRANCH_SUCCESS =
  "FETCH_LISTING_BY_BRANCH_SUCCESS";
export const FETCH_LISTING_BY_BRANCH_FAILED = "FETCH_LISTING_BY_BRANCH_FAILED";
export const FETCH_ACTIVE_LISTING_BY_BRANCH_SUCCESS =
  "FETCH_ACTIVE_LISTING_BY_BRANCH_SUCCESS";
export const FETCH_INACTIVE_LISTING_BY_BRANCH_SUCCESS =
  "FETCH_INACTIVE_LISTING_BY_BRANCH_SUCCESS";

//Generate PDF
export const GENERATE_PDF_START = "GENERATE_PDF_START";
export const GENERATE_PDF_SUCCESS = "GENERATE_PDF_SUCCESS";
export const GENERATE_PDF_FAILED = "GENERATE_PDF_FAILED";

//Delete PDF
export const DELETE_PDF_START = "DELETE_PDF_START";
export const DELETE_PDF_SUCCESS = "DELETE_PDF_SUCCESS";
export const DELETE_PDF_FAILED = "DELETE_PDF_FAILED";

//Error
export const LISTING_ERROR = "LISTING_ERROR";
export const CLEAR_LISTING_ERROR = "CLEAR_LISTING_ERROR";

export const CLEAR_USER_ERROR = "CLEAR_LISTING_ERROR";

/*==========================================================================*/

//Matching Types

//Find Matches

export const FIND_MATCHES_START = "FIND_MATCHES_START";
export const FIND_MATCHES_SUCCESS = "UPDATE_LISTING_SUCCESS";
export const FIND_MATCHES_FAILED = "FIND_MATCHES_FAILED";

//Find Listing matches
export const FIND_LISTING_MATCHES_START = "FIND_LISTING_MATCHES_START";
export const FIND_LISTING_MATCHES_SUCCESS = "FIND_LISTING_MATCHES_SUCCESS";
export const FIND_LISTING_MATCHES_FAILED = "FIND_LISTING_MATCHES_FAILED";

//SPCIALIT TYPES

//COMMERCIAL BUSINESS TYPES

export const FETCH_COMMERCIAL_TYPES = "FETCH_COMMERCIAL_TYPES";
export const FETCH_COMMERCIAL_TYPES_SUCCESS = "FETCH_COMMERCIAL_TYPES_SUCCESS";
export const FETCH_COMMERCIAL_TYPES_FAILED = "FETCH_COMMERCIAL_TYPES_FAILED";
export const EDIT_COMMERCIAL_TYPE = "EDIT_COMMERCIAL_TYPE";

//INDUSTRIAL BUSINESS TYPES

export const FETCH_INDUSTRIAL_TYPES = "FETCH_INDUSTRIAL_TYPES";
export const FETCH_INDUSTRIAL_TYPES_SUCCESS = "FETCH_INDUSTRIAL_TYPES_SUCCESS";
export const FETCH_INDUSTRIAL_TYPES_FAILED = "FETCH_INDUSTRIAL_TYPES_FAILED";
export const EDIT_INDUSTRIAL_TYPE = "EDIT_INDUSTRIAL_TYPE";

//USER TYPES

export const FETCH_USER_TYPES = "FETCH_USER_TYPES";
export const FETCH_USER_TYPES_SUCCESS = "FETCH_USER_TYPES_SUCCESS";
export const FETCH_USER_TYPES_FAILED = "FETCH_USER_TYPES_FAILED";
export const EDIT_USER_TYPE = "EDIT_USER_TYPE";




//
/*=============================================
=            LandLord Types                   =
=============================================*/



/* Create */
export const CREATE_LANDLORD_START = "CREATE_LANDLORD_START";
export const CREATE_LANDLORD_SUCCESS = "CREATE_LANDLORD_SUCCESS";
export const CREATE_LANDLORD_FAILED = "CREATE_LANDLORD_FAILED";



/* Fetch */
export const FETCH_LANDLORD_START = "FETCH_LANDLORD_START";
export const FETCH_LANDLORD_SUCCESS = "FETCH_LANDLORD_SUCCESS";
export const FETCH_LANDLORD_FAILED = "FETCH_LANDLORD_FAILED";

/* Update */
export const UPDATE_LANDLORD_START = "UPDATE_LANDLORD_START";
export const UPDATE_LANDLORD_SUCCESS = "UPDATE_LANDLORD_SUCCESS";
export const UPDATE_LANDLORD_FAILED = "UPDATE_LANDLORD_FAILED";



/*=====  End of LandLord Types  ======*/




export const FETCH_CANCEL_REASONS = "FETCH_CANCEL_REASONS";
export const FETCH_CANCEL_REASONS_SUCCESS = "FETCH_CANCEL_REASONS_SUCCESS";
export const FETCH_CANCEL_REASONS_FAILED = "FETCH_CANCEL_REASONS_FAILED";
export const EDIT_CANCELLATION_REASON = "EDIT_CANCELLATION_REASON";

export const SEND_RESET_EMAIL = "SEND_RESET_EMAIL";
export const SEND_RESET_EMAIL_SUCCESS = "SEND_RESET_EMAIL_SUCCESS";
export const SEND_RESET_EMAIL_FAILED = "SEND_RESET_EMAIL_FAILED";

export const FETCH_PROMOS = "FETCH_PROMOS";
export const FETCH_PROMOS_SUCCESS = "FETCH_PROMOS_SUCCESS";
export const FETCH_PROMOS_FAILED = "FETCH_PROMOS_FAILED";
export const EDIT_PROMOS = "EDIT_PROMOS";

export const FETCH_ALL_USERS = "FETCH_ALL_USERS";
export const FETCH_ALL_USERS_SUCCESS = "FETCH_ALL_USERS_SUCCESS";
export const FETCH_ALL_USERS_FAILED = "FETCH_ALL_USERS_FAILED";
export const EDIT_USER = "EDIT_USER";
export const EDIT_USER_SUCCESS = "EDIT_USER_SUCCESS";
export const EDIT_USER_FAILED = "EDIT_USER_FAILED";
export const DELETE_USER = "DELETE_USER";
export const DELETE_USER_SUCCESS = "DELETE_USER_SUCCESS";
export const DELETE_USER_FAILED = "DELETE_USER_FAILED";

export const FETCH_ALL_DOCTORS = "FETCH_ALL_DOCTORS";
export const FETCH_ALL_DOCTORS_SUCCESS = "FETCH_ALL_DOCTORS_SUCCESS";
export const FETCH_ALL_DOCTORS_FAILED = "FETCH_ALL_DOCTORS_FAILED";
export const UPDATE_BROKER_SUCCESS = "UPDATE_BROKER_SUCCESS"

export const FETCH_ALL_ADMINS_START = "FETCH_ALL_ADMINS_START";
export const FETCH_ALL_ADMINS_SUCCESS = "FETCH_ALL_ADMINS_SUCCESS";
export const FETCH_ALL_ADMINS_FAILED = "FETCH_ALL_ADMINS_FAILED";

export const SAVE_USERS_DEVICE_INFO_START = "SAVE_USERS_DEVICE_INFO_START";
export const SAVE_USERS_DEVICE_INFO_SUCCUSS = "SAVE_USERS_DEVICE_INFO_SUCCUSS";
export const SAVE_USERS_DEVICE_INFO_FAILED = "SAVE_USERS_DEVICE_INFO_FAILED";

export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILED = "FETCH_NOTIFICATIONS_FAILED";

export const FETCH_USER_NOTIFICATIONS = "FETCH_USER_NOTIFICATIONS";
export const FETCH_USER_NOTIFICATIONS_SUCCESS = "FETCH_USER_NOTIFICATIONS_SUCCESS";
export const FETCH_USER_NOTIFICATIONS_FAILED = "FETCH_USER_NOTIFICATIONS_FAILED";

export const EDIT_NOTIFICATIONS = "EDIT_NOTIFICATIONS";
export const SEND_NOTIFICATION = "SEND_NOTIFICATION";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_FAILED = "SEND_NOTIFICATION_FAILED";

export const FETCH_DOCTORS_EARNING = "FETCH_DOCTORS_EARNING";
export const FETCH_DOCTORS__EARNING_SUCCESS = "FETCH_DOCTORS__EARNING_SUCCESS";
export const FETCH_DOCTORS__EARNING_FAILED = "FETCH_DOCTORS__EARNING_FAILED";

export const FETCH_BOOKING_DISCOUNT = "FETCH_BOOKING_DISCOUNT";

export const FETCH_BOOKING__DISCOUNT_SUCCESS =
  "FETCH_BOOKING__DISCOUNT_SUCCESS";
export const FETCH_BOOKING__DISCOUNT_FAILED = "FETCH_BOOKING__DISCOUNT_FAILED";
export const EDIT_BOOKING__DISCOUNT = "EDIT_BOOKING__DISCOUNT";

export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const FETCH_SETTINGS_SUCCESS = "FETCH_SETTINGS_SUCCESS";
export const FETCH_SETTINGS_FAILED = "FETCH_SETTINGS_FAILED";
export const EDIT_SETTINGS = "EDIT_SETTINGS";
export const CLEAR_SETTINGS_ERROR = "CLEAR_SETTINGS_ERROR";

export const FETCH_PAYMENT_METHODS = "FETCH_PAYMENT_METHODS";
export const FETCH_PAYMENT_METHODS_SUCCESS = "FETCH_PAYMENT_METHODS_SUCCESS";
export const FETCH_PAYMENT_METHODS_FAILED = "FETCH_PAYMENT_METHODS_FAILED";
export const UPDATE_WALLET_BALANCE = "UPDATE_WALLET_BALANCE";
export const UPDATE_WALLET_BALANCE_SUCCESS = "UPDATE_WALLET_BALANCE_SUCCESS";
export const UPDATE_WALLET_BALANCE_FAILED = "UPDATE_WALLET_BALANCE_FAILED";
export const CLEAR_PAYMENT_MESSAGES = "CLEAR_PAYMENT_MESSAGES";

export const UPDATE_EVENT_PICKUP = "UPDATE_EVENT_PICKUP";
export const UPDATE_EVENT_DROP = "UPDATE_EVENT_DROP";
export const UPDATE_EVENT_PRACTICE = "UPDATE_EVENT_PRACTICE";
export const UPDATE_SELECTED_POINT_TYPE = "UPDATE_SELECTED_POINT_TYPE";
export const CLEAR_EVENT_POINTS = "CLEAR_EVENT_POINTS";

export const FETCH_TASKS = "FETCH_TASKS";
export const FETCH_TASKS_SUCCESS = "FETCH_TASKS_SUCCESS";
export const FETCH_TASKS_FAILED = "FETCH_TASKS_FAILED";
export const ACCEPT_TASK = "ACCEPT_TASK";
export const CANCEL_TASK = "CANCEL_TASK";

export const FETCH_BOOKING_LOCATION = "FETCH_BOOKING_LOCATION";
export const FETCH_BOOKING_LOCATION_SUCCESS = "FETCH_BOOKING_LOCATION_SUCCESS";
export const FETCH_BOOKING_LOCATION_FAILED = "FETCH_BOOKING_LOCATION_FAILED";
export const STOP_LOCATION_FETCH = "STOP_LOCATION_FETCH";

export const FETCH_DEPENDENT = "FETCH_DEPENDENT";
export const FETCH_DEPENDENT_SUCCESS = "FETCH_DEPENDENT_SUCCESS";
export const FETCH_DEPENDENT_FAIL = "FFETCH_DEPENDENT_FAIL";
export const DELETE_DEPENDENT = "DELETE_DEPENDENT";
export const DELETE_DEPENDENT_SUCCESS = "DELETE_DEPENDENT_SUCCESS";
export const DELETE_DEPENDENT_FAIL = "DELETE_DEPENDENT_FAIL";
export const EDIT_DEPENDENT = "EDIT_DEPENDENT";
export const EDIT_DEPENDENT_SUCCESS = "EDIT_DEPENDENT_SUCCESS";
export const EDIT_DEPENDENT_FAIL = "EDIT_DEPENDENT_FAIL";

export const FETCH_MESSAGES = "FETCH_MESSAGES";
export const FETCH_MESSAGES_SUCCESS = "FETCH_MESSAGES_SUCCESS";
export const FETCH_MESSAGES_FAILED = "FETCH_MESSAGES_FAILED";
export const SEND_MESSAGE = "SEND_MESSAGE";
export const STOP_FETCH_MESSAGES = "STOP_FETCH_MESSAGES";

export const FETCH_CONSULATION_TYPES = "FETCH_CONSULATION_TYPES";
export const FETCH_CONSULATION_TYPES_SUCCESS =
  "FETCH_CONSULATION_TYPES_SUCCESS";
export const FETCH_CONSULATION_TYPES_FAILED = "FETCH_CONSULATION_TYPES_FAILED";
export const ADD_CONSULATION_TYPES = "ADD_CONSULATION_TYPES";
export const ADD_CONSULATION_TYPES_FAILED = "ADD_CONSULATION_TYPES_FAILED";
export const ADD_CONSULATION_TYPES_SUCCESS = "ADD_CONSULATION_TYPES_SUCCESS";

export const FETCH_NOTES = "FETCH_NOTES";
export const FETCH_NOTES_SUCCESS = "FETCH_NOTES_SUCCESS";
export const FETCH_NOTES_FAILED = "FETCH_NOTES_FAILED";
export const SEND_NOTES = "SEND_NOTES";
export const STOP_FETCH_NOTES = "STOP_FETCH_NOTES";

export const FETCH_WITHDRAWS = "FETCH_WITHDRAWS";
export const FETCH_WITHDRAWS_SUCCESS = "FETCH_WITHDRAWS_SUCCESS";
export const FETCH_WITHDRAWS_FAILED = "FETCH_WITHDRAWS_FAILED";
export const EDIT_WITHDRAWS = "EDIT_WITHDRAWS";

export const UPDATE_GPS_LOCATION = "UPDATE_GPS_LOCATION";

export const RECEIVE_APPOINTMENT = "RECEIVE_APPOINTMENT";
export const RECEIVE_DOCTOR = "RECEIVE_DOCTOR";
export const RECEIVE_SEARCH_RESULTS = "RECEIVE_SEARCH_RESULTS";
export const RECEIVE_PATIENTS = "RECEIVE_PATIENTS";
export const RECEIVE_APPOINTMENTS = "RECEIVE_APPOINTMENTS";
///////////////////////////////////////////////////////////////////////////////////
export const CREATE_DOCTORCONFERENCE = "CREATE_DOCTORCONFERENCE";
export const CREATE_DOCTORCONFERENCE_SUCCESS =
  "CREATE_DOCTORCONFERENCE_SUCCESS";
export const CREATE_DOCTORCONFERENCE_FAIL = "CREATE_DOCTORCONFERENCE_FAIL";

export const DELETE_DOCTORCONFERENCE = "DELETE_DOCTORCONFERENCE";
export const DELETE_DOCTORCONFERENCE_SUCCESS =
  "DELETE_DOCTORCONFERENCE_SUCCESS";
export const DELETE_DOCTORCONFERENCE_FAIL = "DELETE_DOCTORCONFERENCE_FAIL";

export const CREATE_NURSECONFERENCE = "CREATE_NURSECONFERENCE";
export const CREATE_NURSECONFERENCE_SUCCESS = "CREATE_NURSECONFERENCE_SUCCESS";
export const CREATE_NURSECONFERENCE_FAIL = "CREATE_NURSECONFERENCE_FAIL";

export const DELETE_NURSECONFERENCE = "DELETE_NURSECONFERENCE";
export const DELETE_NURSECONFERENCE_SUCCESS = "DELETE_NURSECONFERENCE_SUCCESS";
export const DELETE_NURSECONFERENCE_FAIL = "DELETE_NURSECONFERENCE_FAIL";

export const CREATE_JOOMLAUSER = "CREATE_JOOMLAUSER";
export const CREATE_JOOMLAUSER_SUCCESS = "CREATE_JOOMLAUSER_SUCCESS";
export const CREATE_JOOMLAUSER_FAIL = "CREATE_JOOMLAUSER_FAIL";

export const CREATE_OPENFIREUSER = "CREATE_OPENFIREUSER";
export const CREATE_OPENFIREUSER_SUCCESS = "CREATE_OPENFIREUSER_SUCCESS";
export const CREATE_OPENFIREUSER_FAIL = "CREATE_OPENFIREUSER_FAIL";

export const CREATE_MEETINGROOM = "CREATE_MEETINGROOM";
export const CREATE_MEETINGROOM_SUCCESS = "CREATE_MEETINGROOM_SUCCESS";
export const CREATE_MEETINGROOM_FAIL = "CREATE_MEETINGROOM_FAIL";

export const CREATE_DOCTORROOM = "CREATE_MEETINGROOM";
export const CREATE_DOCTORROOM_SUCCESS = "CREATE_MEETINGROOM_SUCCESS";
export const CREATE_DOCTORROOM_FAIL = "CREATE_MEETINGROOM_FAIL";

export const DELETE_MEETINGROOM = "DELETE_MEETINGROOM";
export const DELETE_MEETINGROOM_SUCCESS = "DELETE_MEETINGROOM_SUCCESS";
export const DELETE_MEETINGROOM_FAIL = "DELETE_MEETINGROOM_FAIL";
///////////////////////////////////////////////////////////////////////////////////
export const FETCH_DISEASES = "FETCH_DISEASES";
export const FETCH_DISEASES_SUCCESS = "FETCH_DISEASES_SUCCESS";
export const FETCH_DISEASES_FAILED = "FETCH_DISEASES_FAILED";
export const EDIT_DISEASES = "EDIT_DISEASES";
export const EDIT_DISEASES_SUCCESS = "EDIT_DISEASES_SUCCESS";
export const EDIT_DISEASES_FAILED = "EDIT_DISEASES_FAILED";
export const DELETE_DISEASES = "DELETE_DISEASES";
export const DELETE_DISEASES_SUCCESS = "DELETE_DISEASES_SUCCESS";
export const DELETE_DISEASES_FAILED = "DELETE_DISEASES_FAILED";
//////////////////////////////////////////////////////////////////////////////////
export const ADD_CANVAS = "ADD_CANVAS";
export const ADD_CANVAS_SUCCESS = "ADD_CANVAS_SUCCESS";
export const ADD_CANVAS_FAILED = "ADD_CANVAS_FAILED";
export const FETCH_CANVAS = "FETCH_CANVAS";
export const FETCH_CANVAS_SUCCESS = "FETCH_CANVAS_SUCCESS";
export const FETCH_CANVAS_FAILED = "FETCH_CANVAS_FAILED";
export const EDIT_CANVAS = "EDIT_CANVAS";
export const EDIT_CANVAS_SUCCESS = "EDIT_CANVAS_SUCCESS";
export const EDIT_CANVAS_FAILED = "EDIT_CANVAS_FAILED";
export const DELETE_CANVAS = "DELETE_CANVAS";
export const DELETE_CANVAS_SUCCESS = "DELETE_CANVAS_SUCCESS";
export const DELETE_CANVAS_FAILED = "DELETE_CANVAS_FAILED";
//////////////////////////////////////////////////////////////////////////////////

//push TYPES
export const REGISTER_FOR_NOTIFICATIONS_START = "REGISTER_FOR_NOTIFICATIONS";
export const REGISTER_FOR_NOTIFICATIONS_SUCCESS =
  "REGISTER_FOR_NOTIFICATIONS_SUCCESS";
export const REGISTER_FOR_NOTIFICATIONS_FAILURE =
  "REGISTER_FOR_NOTIFICATIONS_FAILURE";

export const FETCH_NOTIFICATIONS_START = "FETCH_NOTIFICATIONS";

export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const SEND_NOTIFICATIONS_START = "SEND_NOTIFICATIONS";
export const SEND_NOTIFICATIONS_SUCCESS = "SEND_NOTIFICATIONS_SUCCESS";
export const SEND_NOTIFICATIONS_FAILURE = "SEND_NOTIFICATIONS_FAILURE";

//CHAT TYPES
export const FETCH_USERS_CHATS_START = "FETCH_USERS_CHATS_START";
export const FETCH_USERS_CHATS_SUCCESS = "FETCH_USERS_CHATS_SUCCESS";
export const FETCH_USERS_CHATS_FAILURE = "FETCH_USERS_CHATS_FAILURE";

export const CREATE_CHATS_START = "CREATE_CHATS_START";
export const CREATE_CHATS_SUCCESS = "CREATE_CHATS_SUCCESS";
export const CREATE_CHATS_FAILURE = "CREATE_CHATS_FAILURE";

//FETCH MESSAGES TYPES
export const FETCH_USERS_MESSAGES_START = "FETCH_USERS_MESSAGES_START";
export const FETCH_USERS_MESSAGES_SUCCESS = "FETCH_USERS_MESSAGES_SUCCESS";
export const FETCH_USERS_MESSAGES_FAILURE = "FETCH_USERS_MESSAGES_FAILURE";

//SEND MESSAGES TYPES
export const SEND_MESSAGE_START = "SEND_MESSAGE_START";
export const SEND_MESSAGE_SUCCUSS = "SEND_MESSAGE_SUCCUSS";
export const SEND_MESSAGE_FAILED = "SEND_MESSAGE_FAILED";

// PUBLICATION PROP24
export const ADD_PUBLISH = "ADD_PUBLISH";
export const ADD_PUBLISH_SUCCESS = "ADD_PUBLISH_SUCCESS";
export const ADD_PUBLISH_FAILED = "ADD_PUBLISH_FAILED";

export const FETCH_PUBLISH = "FETCH_PUBLISH";
export const FETCH_PUBLISH_SUCCESS = "FETCH_PUBLISH_SUCCESS";
export const FETCH_PUBLISH_FAILED = "FETCH_PUBLISH_FAILED";

// PUBLICATION WEBSITE
export const ADD_PUBLISH_WEBSITE = "ADD_PUBLISH_WEBSITE";
export const ADD_PUBLISH_WEBSITE_SUCCESS = "ADD_PUBLISH_WEBSITE_SUCCESS";
export const ADD_PUBLISH_WEBSITE_FAILED = "ADD_PUBLISH_WEBSITE_FAILED";

export const FETCH_PUBLISH_WEBSITE = "FETCH_PUBLISH_WEBSITE";
export const FETCH_PUBLISH_WEBSITE_SUCCESS = "FETCH_PUBLISH_WEBSITE_SUCCESS";
export const FETCH_PUBLISH_WEBSITE_FAILED = "FETCH_PUBLISH__FAILED";

// PUBLICATION PRIVATE PROPERTY
export const ADD_PRIVATE_PROP_PUBLISH = "ADD_PRIVATE_PROP_PUBLISH";
export const ADD_PRIVATE_PROP_PUBLISH_SUCCESS = "ADD_PRIVATE_PROP_PUBLISH_SUCCESS";
export const ADD_PRIVATE_PROP_PUBLISH_FAILED = "ADD_PRIVATE_PROP_PUBLISH_FAILED";

export const FETCH_PRIVATE_PROP_PUBLISH = "FETCH_PRIVATE_PROP_PUBLISH";
export const FETCH_PRIVATE_PROP_PUBLISH_SUCCESS = "FETCH_PRIVATE_PROP_PUBLISH_SUCCESS";
export const FETCH_PRIVATE_PROP_PUBLISH_FAILED = "FETCH_PRIVATE_PROP_PUBLISH_FAILED";

// Joomla Contact
export const ADD_CONTACT = "ADD_CONTACT";
export const ADD_CONTACT_SUCCESS = "ADD_CONTACT_SUCCESS";
export const ADD_CONTACT_FAILED = "ADD_CONTACT_FAILED";

export const FETCH_CONTACT = "FETCH_CONTACT";
export const FETCH_CONTACT_SUCCESS = "FETCH_CONTACT_SUCCESS";
export const FETCH_CONTACT_FAILED = "FETCH_CONTACT_FAILED";

// Joomla user
export const ADD_JM_USER = "ADD_JM_USER";
export const ADD_JM_USER_SUCCESS = "ADD_JM_USER_SUCCESS";
export const ADD_JM_USER_FAILED = "ADD_JM_USER_FAILED";

export const FETCH_JM_USER = "FETCH_JM_USER";
export const FETCH_JM_USER_SUCCESS = "FETCH_JM_USER_SUCCESS";
export const FETCH_JM_USER_FAILED = "FETCH_JM_USER_FAILED";

//creating agents in prop24
export const ADD_AGENT = "ADD_AGENT";
export const ADD_AGENT_SUCCESS = "ADD_AGENT_SUCCESS";
export const ADD_AGENT_FAILED = "ADD_AGENT_FAILED";

export const FETCH_AGENTS = "FETCH_AGENTS";
export const FETCH_AGENTS_SUCCESS = "FETCH_AGENTS_SUCCESS";
export const FETCH_AGENTS_FAILED = "FETCH_AGENTS_FAILED";

export const DELETE_AGENT = "DELETE_AGENT";
export const DELETE_AGENT_SUCCESS = "DELETE_AGENT_SUCCESS";
export const DELETE_AGENT_FAILED = "DELETE_AGENT_FAILED";

export const EDIT_AGENT = "EDIT_AGENT";
export const EDIT_AGENT_SUCCESS = "EDIT_AGENT_SUCCESS";
export const EDIT_AGENT_FAILED = "EDIT_AGENT_FAILED";

//creating agents in private property
export const ADD_PP_AGENT = "ADD_PP_AGENT";
export const ADD_AGENT_PP_SUCCESS = "ADD_AGENT_PP_SUCCESS";
export const ADD_AGENT_PP_FAILED = "ADD_AGENT_PP_FAILED";



///FETCH BROKER

export const FETCH_BROKER = "FETCH_BROKER";
export const FETCH_BROKER_SUCCESS = "FETCH_BROKER_SUCCESS";
export const FETCH_BROKER_FAILED = "FETCH_BROKER_FAILED";

export const CLEAR_PUB_ERROR = "CLEAR_PUB_ERROR";

//PROVINCES AND CITIES AND SUBURBS

export const FETCH_CITIES = "FETCH_CITIES";
export const FETCH_CITIES_SUCCESS = "FETCH_CITIES_SUCCESS";
export const FETCH_CITIES_FAILED = "FETCH_CITIES_FAILED";

export const FETCH_SUBURBS = "FETCH_SUBURBS";
export const FETCH_SUBURBS_SUCCESS = "FETCH_SUBURBS_SUCCESS";
export const FETCH_SUBURBS_FAILED = "FETCH_SUBURBS_FAILED";

export const FETCH_PROVINCE = "FETCH_PROVINCE";
export const FETCH_PROVINCE_SUCCESS = "FETCH_PROVINCE_SUCCESS";
export const FETCH_PROVINCE_FAILED = "FETCH_PROVINCE_FAILED";

export const UPDATE_USER_NOTIFICATIONS = "UPDATE_USER_NOTIFICATIONS";
export const UPDATE_USER_NOTIFICATIONS_SUCCESS = "UPDATE_USER_NOTIFICATIONS_SUCCESS";
export const UPDATE_USER_NOTIFICATIONS_FAILED = "UPDATE_USER_NOTIFICATIONS_FAILED";

export const FETCH_PP_CITIES = "FETCH_PP_CITIES";
export const FETCH_PP_CITIES_SUCCESS = "FETCH_PP_CITIES_SUCCESS";
export const FETCH_PP_CITIES_FAILED = "FETCH_PP_CITIES_FAILED";

export const FETCH_PP_SUBURBS = "FETCH_PP_SUBURBS";
export const FETCH_PP_SUBURBS_SUCCESS = "FETCH_PP_SUBURBS_SUCCESS";
export const FETCH_PP_SUBURBS_FAILED = "FETCH_PP_SUBURBS_FAILED";